/*  */

import React, { useEffect, useState, } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom"
import { koalaImg } from "utility/koalaImg";

import { Button } from "antd";
import { Image } from "antd";
import ModalAlert from "components/modal/ModalAlert";
import wait from "../../assets/imgage/wordBook/koalaWait.png"
import helper from "services/helper";
import ModalHowToPlay from "./ModalHowToPlay";
import GetCurrentPoint from "../profile/GetCurrentPoint";
import { WordBookQuizView } from "services/Api/Module/WordBook";
import wordBookButton from "../../assets/imgage/wordBook/wordbookButton.png"
import { RightOutlined, LeftOutlined, HomeFilled, ArrowLeftOutlined } from '@ant-design/icons';
import heart from "../../assets/imgage/wordBook/ico-heart.svg"

const WordBookQuiz = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const [openPopup, setOpenPopup] = useState(false);
    const [openHowToPlay, setOpenHowToPlay] = useState(false);
    const [tootip, setTootip] = useState(false);
    const navigate = useNavigate();
    const stateProfile = useSelector((state) => state.profile.dataUser);
    const stateCurrentPoint = useSelector((state) => state.currentPoint);
    const redeemHeart = stateCurrentPoint.redeemHeart;
    const newCurrentHeart = redeemHeart ? 10 : stateCurrentPoint.currentHeart;
    const customerId = stateProfile.id;
    const [wordBookData, setWordBookData] = useState([]);
    const [currentPage, setCurrentPage] = useState(+searchParams.get("page") || 1);
    const [filter, setFilter] = useState(null);
    const [lastPage, setLastPage] = useState(0);
    const limit = 8;



    useEffect(() => {
        fetchWordBookQuizView();
        document.documentElement.scrollTop = 0;
    }, [currentPage]);

    useEffect(() => {
        fetchWordBookQuizView();
    }, [filter]);

    const getWordBookQuizView = async () => {
        let _return = {
            status: false,
            result: {},
            rowCount: 0,
        };
        try {
            const { data } = await WordBookQuizView({
                data: {
                    customer: customerId,
                    limit: limit,
                    offset: (limit * (currentPage - 1)),
                    finish: filter
                }
            });
            if (data.resultCode === "20000") {
                const resData = data.resultData;

                _return.status = true;
                _return.result = resData;
                _return.rowCount = data.rowCount;
            } else {
                navigate("/word-book-main");
            }
        } catch (e) {
            console.log(e);
            return _return;
        }
        return _return;
    };

    const fetchWordBookQuizView = async () => {
        try {
            const resData = await getWordBookQuizView();
            setWordBookData(resData.result);
            const check = resData.rowCount / limit
            setLastPage(Math.ceil(check))
        } catch (err) {
            console.log(err);
        }
    };

    const onClickPreviuos = async () => {
        try {
            const old = currentPage
            setCurrentPage(old - 1)
        } catch (err) {
            console.log(err);
        }
    };

    const onClickNext = async () => {
        try {
            const old = currentPage
            setCurrentPage(old + 1)
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeFilter = async (e) => {
        console.log(e.target.value)
        setCurrentPage(1)
        if (e.target.value === "1") {
            setFilter(null)
        } else if (e.target.value === "2") {
            setFilter(true)
        } else {
            setFilter(false)
        }
    }



    return (
        <div>
            <GetCurrentPoint />
            <Helmet>
                <title>โคอะลา มาร์ช</title>
                <meta name="title" content="โคอะลา มาร์ช" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="โคอะลา มาร์ช" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>

            <div id="pageWordBookQuiz">
                {/* <!-- Content Page --> */}
                <main>
                    <div className="wrapContent">
                        <div className="bTop">
                        <div style={{display:'flex' , marginTop:'5px'}}>
                                <a className="btnGoBack" onClick={() => navigate('/word-book-main')}>
                                </a>
                                <a className="btnGoHome" onClick={() => navigate('/profile')}>
                                </a>
                            </div>

                            <div className="divHeart">
                            <Image preview={false} src={heart}></Image>
                                <span>{newCurrentHeart}/10</span>
                                <a className="iconInfo" onClick={() => setTootip(true)}></a>
                                <div className="bTips" style={{ display: tootip ? 'block' : 'none' }} >
                                    <a className="btnCloseTips" onClick={() => setTootip(false)}></a>
                                    <p className="bold">เก็บหัวใจครบ 10 ดวง <br></br>เพื่อแลกของรางวัล</p>
                                    <p>
                                        เก็บสะสม Wordbook จากการสแกน สะสมคะแนน เพื่อตอบคำถามในกิจกรรม ตอบ 1 คำถาม รับไปเลย 1 ดวง!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <section id="wordBookQuiz">
                            <div className="pContent">
                                <div className="pDropdown">
                                    <p>คำถาม Wordbook</p>
                                    <select className="select wb" onChange={(e) => handleChangeFilter(e)}>
                                        <option value="1">
                                            ทั้งหมด
                                        </option>
                                        <option value="2">
                                            สำเร็จแล้ว
                                        </option>
                                        <option value="3">
                                            ยังไม่สำเร็จ
                                        </option>
                                    </select>
                                </div>
                                {wordBookData && wordBookData.map((item, index) => {
                                    return (
                                        item.status === 'active' ?
                                            <>
                                                <div className="pBanner">
                                                    <div className="pQuestionImg">
                                                        <Image preview={false} src={item.img}></Image>
                                                    </div>
                                                    <div className="pQuestionTxt">
                                                        <p>{item.description}</p>
                                                        <button className="pQuestionBtn" onClick={() => navigate(`/word-book-answer?id=${item.id}&page=${currentPage}`)}> ตอบ </button>
                                                    </div>
                                                    <div className="pStar"><p>{item.name}</p></div>

                                                </div>

                                            </>
                                            : item.status === 'wait' ?
                                                <div className="pBannerWait">
                                                    <div className="pQuestionImg">
                                                        <Image preview={false} src={wait}></Image>
                                                    </div>
                                                    <p className="pQuestionTxt">Coming soon</p>
                                                </div>
                                                :
                                                <div className="pBanner">
                                                    <div className="pQuestionImg">
                                                        <Image preview={false} src={item.img}></Image>
                                                    </div>
                                                    <div className="pQuestionTxt">
                                                        <p>{item.description}</p>
                                                        <button className="pQuestionBtn"> ตอบ </button>
                                                    </div>
                                                    <div className="pStar"><p>{item.name}</p></div>
                                                    <div class="overlay">
                                                        <div class="label"></div>
                                                    </div>
                                                </div>
                                    )
                                })}

                            </div>
                            <div className="myWordBtn" onClick={() => navigate('/word-book-all')}>
                                <Image src={wordBookButton} preview={false}></Image>
                            </div>
                            <div className="pPaging">
                                <button className="btnPrevious" disabled={currentPage === 1}
                                    onClick={() => onClickPreviuos()}
                                ><LeftOutlined /></button>
                                <p>{currentPage}/{lastPage}</p>
                                <button className="btnNext" disabled={currentPage === lastPage}
                                    onClick={() => onClickNext()}
                                ><RightOutlined /></button>
                            </div>
                        </section>

                    </div>
                </main>
            </div >
            <ModalAlert
                open={openPopup}
                title='title'
                subTitle='subTitle'
                content='content'
                onClose={() => setOpenPopup(false)}
            />
            <ModalHowToPlay
                isOpen={openHowToPlay}
                onClose={() => setOpenHowToPlay(false)}
            />
        </div >
    );
};

export default WordBookQuiz;
